import React from 'react'
import type { UpgradeReviewRow, UpgradeTally } from './review-types'
import { REVIEW_COPY } from './review-copy'

const totalItems = (rows: UpgradeReviewRow[]) =>
    rows.reduce((total, row) => total + (row.diff_summary.rows_total || 0), 0)

const matchingItems = (rows: UpgradeReviewRow[]) =>
    rows.reduce((total, row) => total + (row.diff_summary.rows_match || 0), 0)

const Stat = ({ value, children, color = '#1C2127' }: any) => (
    <div className="flex-1 rounded border border-[#E5E7EB] bg-white px-[18px] py-4">
        <div
            className="text-[28px] font-semibold leading-[34px] tracking-[-0.01em]"
            style={{ color }}
        >
            {value}
        </div>
        <div className="text-sm leading-[21px] text-[#5F6B7C]">{children}</div>
    </div>
)

export const UpgradeReviewTally = ({
    tally,
    rows,
}: {
    tally: UpgradeTally
    rows: UpgradeReviewRow[]
}) => {
    const total = totalItems(rows)
    const matches = matchingItems(rows)
    return (
        <div className="space-y-3">
            <div className="flex gap-5">
                <Stat value={tally.ok} color="#1C6E42">
                    Identical, ready to upgrade
                </Stat>
                <Stat value={tally.differences} color="#935610">
                    Have differences to review
                </Stat>
                <Stat value={matches}>
                    {REVIEW_COPY.itemsMatch(
                        matches,
                        total,
                        rows.map((row) => row.ad_type),
                    )}
                </Stat>
            </div>
            <div className="text-xs text-[#5F6B7C]">
                {tally.total} Recipe{tally.total === 1 ? '' : 's'} · {tally.ok} identical ·{' '}
                {tally.differences} with differences · {tally.unparseable} need fixing ·{' '}
                {tally.upgraded} upgraded · {tally.pending} checking
            </div>
        </div>
    )
}
